import { AfterViewInit, Component, ElementRef, inject, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'era-pair-code-input-ui',
  templateUrl: './pair-code-input.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule],
})
export class PairCodeInputComponent implements AfterViewInit {
  private readonly router = inject(Router);
  private readonly formBuilder = inject(UntypedFormBuilder);

  readonly codeInput = viewChild.required<ElementRef>('codeInput');

  public readonly codeForm: UntypedFormGroup;
  public formText: string;
  private replacedText: string | null;

  constructor() {
    this.codeForm = this.createForm();
  }

  get codeControl(): AbstractControl | null {
    return this.codeForm.get('code');
  }

  private createForm(): UntypedFormGroup {
    return this.formBuilder.group({
      code: [
        '',
        [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('^[0-9]{1,6}$')],
      ],
    });
  }

  public save() {
    if (this.codeForm.status !== 'VALID') {
      return false;
    }

    const code = this.codeControl?.value;
    void this.router.navigate(['/pair', code]);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const codeInput = this.codeInput();
      if (codeInput) {
        codeInput.nativeElement.focus();
      }
    });
  }

  onPaste(event: ClipboardEvent) {
    if (event?.clipboardData) {
      const clipboardData = event.clipboardData;
      const pastedText = clipboardData.getData('text');
      this.replacedText = pastedText.replace(/\r?\n|\r/g, '');
    }
  }

  onInput() {
    if (this.replacedText) {
      this.formText = this.replacedText;
      this.replacedText = null;
    }
  }
}
